module.exports = __webpack_public_path__ + "static/media/440d90888f85fd1da96df9439f9dbe59.7537138b.jpg";